
Greenmile.Checks = Greenmile.Checks || {};
Greenmile.Checks.EventCheck = Greenmile.Checks.EventCheck || {};

Greenmile.Checks.EventCheck.OSDMonitoring = {

  template() {
    return {
      items: [{
        attributes: {
          "id": 'OSDMonitoringEvent'
        },
        items: [
          {
            attributes: {
              class: 'control-group',
              id: 'onlyOneEventPerStopContainer'
            }
          },
          {
            attributes: {
              class: 'control-group',
              id: 'overReasonsContainer'
            }
          },
          {
            attributes: {
              class: 'control-group',
              id: 'shortReasonsContainer'
            }
          },
          {
            attributes: {
              class: 'control-group',
              id: 'damageReasonsContainer'
            }
          }
        ]
      }]
    };
  },

  renderFields() {
    //Create Monet fields
    const overReasons = new Monet.UI.Fields.Render({
      name: 'overReasons',
      label: 'event.osd.over',
      mandatory: false,
      type: 'LOOKUP_LIST',
      lookupEntity: 'ReasonCode',
      lookupEntityColumn: 'description'
    }, 'Event').render();

    const shortReasons = new Monet.UI.Fields.Render({
      name: 'shortReasons',
      label: 'event.osd.short',
      mandatory: false,
      type: 'LOOKUP_LIST',
      lookupEntity: 'ReasonCode',
      lookupEntityColumn: 'description'
    }, 'Event').render();

    const damageReasons = new Monet.UI.Fields.Render({
      name: 'damageReasons',
      label: 'event.osd.damage',
      mandatory: false,
      type: 'LOOKUP_LIST',
      lookupEntity: 'ReasonCode',
      lookupEntityColumn: 'description'
    }, 'Event').render();

    const onlyOneEventPerStop = new Monet.UI.Fields.Render({
      name: 'onlyOneEventPerStop',
      label: 'event.osd.onlyOneEventPerStop',
      mandatory: false,
      type: 'CHECKBOX',
    }, 'Event').render();

    Greenmile.Checks.EventCheck.OSDMonitoring.fields = { 
      overReasons, 
      shortReasons, 
      damageReasons, 
      onlyOneEventPerStop 
    };


    //Append fields to DOM  
    const overReasonsContainer = document.querySelector('#OSDMonitoringEvent #overReasonsContainer');
    overReasonsContainer.appendChild(overReasons.rootEl);

    const shortReasonsContainer = document.querySelector('#OSDMonitoringEvent #shortReasonsContainer');
    shortReasonsContainer.appendChild(shortReasons.rootEl);

    const damageReasonsContainer = document.querySelector('#OSDMonitoringEvent #damageReasonsContainer');
    damageReasonsContainer.appendChild(damageReasons.rootEl);

    const onlyOneEventPerStopContainer = document.querySelector('#OSDMonitoringEvent #onlyOneEventPerStopContainer');
    onlyOneEventPerStopContainer.appendChild(onlyOneEventPerStop.rootEl);

  },

  assignParameter(jsonParam) {
    Greenmile.Checks.EventCheck.OSDMonitoring.renderFields();
    const fields = Greenmile.Checks.EventCheck.OSDMonitoring.fields;
    if (jsonParam) {
      jsonParam = JSON.parse(jsonParam);
      fields.overReasons.setValue(jsonParam.over.reasons);
      fields.shortReasons.setValue(jsonParam.short.reasons);
      fields.damageReasons.setValue(jsonParam.damage.reasons);
      fields.onlyOneEventPerStop.setValue(jsonParam.onlyOneEventPerStop);
    }
  },

  retrieveParameter() {
    const fields = Greenmile.Checks.EventCheck.OSDMonitoring.fields;

    return JSON.stringify({
      over: { reasons: fields.overReasons.getFullValue().map(field => field.id.toString()) },
      short: { reasons: fields.shortReasons.getFullValue().map(field => field.id.toString()) },
      damage: { reasons: fields.damageReasons.getFullValue().map(field => field.id.toString()) },
      onlyOneEventPerStop: fields.onlyOneEventPerStop.getValue()
    });
  }

};